import React from 'react';

export const SentenceDisplay = ({ 
  segment, 
  subject, 
  currentWord, 
  onWordClick, 
  onWordPlay 
}) => {
  if (!segment.hasOwnProperty('words')) return null;

  return (
    <div className='flex flex-wrap gap-3 p-4 lg:p-6 bg-white/80 backdrop-blur-sm rounded-2xl border border-white/40 shadow-lg shadow-blue-500/5'>
      {segment.words.map((item, i) => (
        <div key={i+"block"} className='flex flex-col items-center group'>
          <button 
            disabled={(subject.language === "English")}
            className={`text-lg font-medium text-center transition-all duration-300 p-3 rounded-xl border bg-white text-gray-800 border-gray-300 hover:bg-gray-50 hover:shadow-md hover:border-gray-400 hover:transform hover:scale-105" 
                `}
            onClick={() => onWordClick(item.text.toLowerCase())}
          >
            {item.text}
          </button>
          
          <button 
            className={`w-12 h-2 rounded-full transition-all duration-300 mt-2 ${
              (currentWord === i) 
                ? "bg-gradient-to-r from-green-500 to-emerald-500 shadow-lg shadow-green-500/25 transform scale-110" 
                : "bg-gray-300 hover:bg-gray-400 hover:shadow-sm"
            }`}
            onClick={() => onWordPlay(i, item)}
          />
        </div>
      ))}
    </div>
  );
};